import IconButton from "@mui/material/IconButton";
import { ChevronLeft } from "lucide-react";
import { useHistory } from "react-router-dom";

interface BackButtonProps {
	onClick?: () => void;
	testId?: string;
}

export function BackButton({
	onClick,
	testId = "back-button",
}: BackButtonProps) {
	const history = useHistory();

	return (
		<IconButton
			onClick={onClick ?? (() => history.goBack())}
			className="p-8 text-black border-radius-8 align-self-start"
			data-test-id={testId}
		>
			<ChevronLeft className="icon-small" />
		</IconButton>
	);
}

export function PathBackButton({
	testId = "back-button",
}: {
	testId?: string;
}) {
	const history = useHistory();

	return (
		<IconButton
			onClick={() => history.goBack()}
			className="p-8 text-black border-radius-8 align-self-start"
			data-test-id={testId}
		>
			<ChevronLeft className="icon-small" />
		</IconButton>
	);
}
